export default {
  "cart-layout": () => import("/app/src/layouts/cart-layout.vue").then(m => m.default || m),
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  "info-layout": () => import("/app/src/layouts/info-layout.vue").then(m => m.default || m)
}